import {InternalLinkType} from '@/store/content-optimizer/CurrentPageModel';
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {Spin, Tooltip} from 'antd';
import styled from 'styled-components';
import {
  faCheck,
  faStar,
} from '@fortawesome/pro-regular-svg-icons';
import {faStar as faStarSolid} from '@fortawesome/pro-solid-svg-icons';
import {useEffect, useState} from 'react';
import {observer} from 'mobx-react';
import {faXmark} from '@fortawesome/pro-light-svg-icons';
import {useStore} from '@/store/root-store';
import {LoadingOutlined} from '@ant-design/icons';
import {NextImg} from '@/utils/nextImg';

interface Props {
  link: InternalLinkType;
  customCallback?: () => void;
}
export const SingleSuggestion = observer(({link, customCallback}: Props) => {
  const [copySuccess, setCopySuccess] = useState(false);
  const [isRemovingTerm, setIsRemovingTerm] = useState(false);
  const [isBookmarked, setIsBookmarked] = useState(link?.isBookmarked);
  const {contentOptimizer: {currentPage: {removeInternalLinkSuggestion, bookmarkInternalLinkSuggestion, content: {uuid}}}} = useStore('');

  const antdIcon = <LoadingOutlined style={{fontSize: '12px', color: '#7f4ead', marginLeft: 13}} spin />;

  useEffect(() => {
    setIsBookmarked(link?.isBookmarked);
  }, [link?.isBookmarked]);

  return <SingleLinkContainer>
    <Left>
      <FontAwesomeIcon icon={faCheck} style={{color: link?.isUsed ? '#1FAC47' : '#4E5156', margin: 'auto'}}/>
    </Left>
    <Tooltip title={link?.snippet} placement='left' overlayInnerStyle={{background: '#000', borderRadius: 8}}>
      <Right>
        <TitleAndStar>
          <Title>
            {link?.title ? link.title : ''}
          </Title>
          {isBookmarked ? <FontAwesomeIcon icon={faStarSolid} style={{color: '#F1AA3E'}} fontSize={14}/> : null}
        </TitleAndStar>

        <Link href={link?.url} target='_blank' rel='noreferrer'>
          {link?.path}
        </Link>
      </Right>
    </Tooltip>
    <div className='actionsMenu'>
      <Tooltip
        title={link?.isBookmarked ? 'Link bookmarked' : 'Bookmark link'}
        placement='top'
        overlayClassName='copyTooltip'>
        <div style={{width: 20}} onClick={async () => {
          setIsBookmarked(!isBookmarked);
          await bookmarkInternalLinkSuggestion(uuid, link?.url);
          if (typeof customCallback == 'function') customCallback();
        }}>
          <FontAwesomeIcon icon={isBookmarked ? faStarSolid : faStar} style={{color: isBookmarked ? '#F1AA3E' : '#fff'}} fontSize={14}/>
        </div>
      </Tooltip>
      <Tooltip
        title={copySuccess ? <span><FontAwesomeIcon icon={faCheck} style={{color: '#2AC155'}}/>{` URL Copied`}</span> : 'Copy URL'}
        placement='top'
        overlayClassName='copyTooltip'
        onVisibleChange={visible => {
          if (!visible) {
            setTimeout(() => {
              setCopySuccess(false);
            }, 300);
          }
        }}>
        <div style={{width: 20}} onClick={() => {
          navigator.clipboard.writeText(link?.url);
          setCopySuccess(true);
        }}>
          <NextImg style={{width: '12px', marginLeft: 5}} src={'/img/copy-white.svg'}/>
        </div>
      </Tooltip>
      <Tooltip
        title={'Remove link'}
        placement='top'
        overlayClassName='copyTooltip'>
        <div style={{width: 20}} onClick={async () => {
          setIsRemovingTerm(true);
          await removeInternalLinkSuggestion(uuid, link?.url, link?.keywords);
          if (typeof customCallback == 'function') customCallback();
          setIsRemovingTerm(false);
        }}>
          {isRemovingTerm ? <Spin indicator={antdIcon}/> : <FontAwesomeIcon icon={faXmark} fontSize={16} style={{marginLeft: 10}}/>}
        </div>
      </Tooltip>
    </div>

  </SingleLinkContainer>;
});

const SingleLinkContainer = styled.div`
  margin-bottom: 12px;
  display: flex;
  justify-content: space-between;
  position: relative;

  .actionsMenu {
    display: none;
    font-size: 12px;
    margin-bottom: auto;
    margin-left: 5px;
    margin-top: auto;
    cursor: pointer !important;
    position: absolute;
    background: linear-gradient(90deg, #2d2f342b -10.83%,  #2d2f34 39.77%);
    padding-left: 30px;
    right: 0;
  }

  &:hover {
    .actionsMenu {
      display: flex;
    }
  }

  .copyTooltip {
    :global(.ant-tooltip-content) {
      background-color: $color-gray-dark;
      border-radius: 10px !important;
    }
  
    :global(.ant-tooltip-arrow) {
      display: none !important;
    }
  
    :global(.ant-tooltip-inner) {
      border-radius: 10px !important;
      padding-left: 10px !important;
      padding-right: 10px !important;
    }
  }
`;
const Right = styled.div`
  width: 90%;
  margin-right: auto;
`;
const Left = styled.div`
  display: flex;
  width: 10%;
`;
const TitleAndStar = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
`;
const Title = styled.div`
  cursor: pointer;
  color: #e8e8e8 !important;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 90%;
`;
const Link = styled.a`
  font-size: 12px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
  color: #34AEF3;

  &:hover {
    text-decoration: underline;
  }
`;


